import './AnalyticsView.scss';

import AnalyticsView from './AnalyticsView';

export default AnalyticsView;
